import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectorComponent } from './selector/selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrandModule } from '../brand/brand.module';
import { CardComponent } from './card/card.component';
import { MatTabsModule } from '@angular/material/tabs';
import { InfoComponent } from './info/info.component';
import { AnalogueListComponent } from './analogue-list/analogue-list.component';
import { AnalogueManualPickerDialogComponent } from './analogue-panel-v2/analogue-manual-picker-dialog.component';
import { AnaloguePanelV2Component } from './analogue-panel-v2/analogue-panel-v2.component';
import { AnaloguePanelV2DialogComponent } from './analogue-panel-v2/analogue-panel-v2-dialog.component';
import { AnalogueSupplierGroupSelectDialogComponent } from './analogue-panel-v2/analogue-supplier-group-select-dialog.component';
import { MatListModule } from '@angular/material/list';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { WarehouseModule } from '../warehouse/warehouse.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { FolderModule } from '../folder/folder.module';
import { PropertiesComponent } from './info/properties/properties.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MoveComponent } from './move/move.component';
import { BarcodeModule } from '../barcode/barcode.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProfileComponent } from './profile/profile.component';
import { PropertyModule } from '../property/property.module';
import { StockTableComponent } from './stock-table/stock-table.component';
import { EditStockComponent } from './edit-stock/edit-stock.component';
import { BarcodesComponent } from './barcodes/barcodes.component';
import { RouterModule } from '@angular/router';
import { SetNewPriceComponent } from './set-new-price/set-new-price.component';
import { MatMenuModule } from '@angular/material/menu';
import { RemoveDoubleComponent } from './remove-double/remove-double.component';
import { AddImageComponent } from './add-image/add-image.component';
import { NameUpdateComponent } from './name-update/name-update.component';
import { ProductListComponent } from './product-list/product-list.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FoldersComponent } from './folders/folders.component';
import { EshopModule } from '../eshop/eshop.module';
import { EshopLinksComponent } from './eshop-links/eshop-links.component';
import { AddEshopLinkComponent } from './add-eshop-link/add-eshop-link.component';
import { PrintPriceTagComponent } from './print-price-tag/print-price-tag.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ArticleListComponent } from './article-list/article-list.component';
import { AddArticleComponent } from './add-article/add-article.component';
import { UploadNewCardsComponent } from './upload-new-cards/upload-new-cards.component';
import { NewSelectorComponent } from './new-selector/new-selector.component';
import { ProductListItemComponent } from './product-list-item/product-list-item.component';
import { ProductStockListComponent } from './product-stock-list/product-stock-list.component';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ProductTableComponent } from './product-table/product-table.component';
import { CreateComponent } from './create/create.component';
import { SearchKeyManagerComponent } from './search-key-manager/search-key-manager.component';
import { SearchKeyCreateComponent } from './search-key-create/search-key-create.component';
import { CatalogStockDialogComponent } from './catalog-stock-dialog/catalog-stock-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { ExistImportSelectionDialogComponent } from './exist-import-selection-dialog/exist-import-selection-dialog.component';
import { ProviderModule } from '../provider/provider.module';
import { ProductAiEnrichmentDialogComponent } from './profile/product-ai-enrichment-dialog.component';
import { PhotoViewerModule } from '../shared/photo-viewer/photo-viewer.module';
import { ProcurementMinimumStockModule } from '../procurement/analytics/procurement-minimum-stock.module';
import { ProductSalesComponent } from './profile/product-sales.component';
import { ProductWarehouseTableComponent } from './profile/product-warehouse-table.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateModule } from '@angular/material-moment-adapter';
@NgModule({
  declarations: [
    SelectorComponent,
    CardComponent,
    InfoComponent,
    AnalogueListComponent,
    AnaloguePanelV2Component,
    AnaloguePanelV2DialogComponent,
    AnalogueManualPickerDialogComponent,
    AnalogueSupplierGroupSelectDialogComponent,
    PropertiesComponent,
    MoveComponent,
    ProfileComponent,
    ProductSalesComponent,
    ProductWarehouseTableComponent,
    StockTableComponent,
    EditStockComponent,
    BarcodesComponent,
    SetNewPriceComponent,
    RemoveDoubleComponent,
    AddImageComponent,
    NameUpdateComponent,
    ProductListComponent,
    FoldersComponent,
    EshopLinksComponent,
    AddEshopLinkComponent,
    PrintPriceTagComponent,
    GalleryComponent,
    ArticleListComponent,
    AddArticleComponent,
    UploadNewCardsComponent,
    NewSelectorComponent,
    ProductListItemComponent,
    ProductStockListComponent,
    CatalogueComponent,
    ProductTableComponent,
    CreateComponent,
    SearchKeyManagerComponent,
    SearchKeyCreateComponent,
    CatalogStockDialogComponent,
    ExistImportSelectionDialogComponent,
    ProductAiEnrichmentDialogComponent
  ],
  exports: [
    CreateComponent,
    SelectorComponent,
    CardComponent,
    BarcodesComponent,
    StockTableComponent,
    AnalogueListComponent,
    AnaloguePanelV2Component,
    SetNewPriceComponent,
    ProductListComponent,
    ProductTableComponent
  ],
  imports: [
    ProcurementMinimumStockModule,
    MatDatepickerModule,
    MomentDateModule,
    RouterModule,
    CommonModule,
    MatBottomSheetModule,
    FormsModule,
    MatSidenavModule,
    MatInputModule,
    MatFormFieldModule,
    MatSortModule,
    MatButtonModule,
    MatTableModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatTooltipModule,
    BrandModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatListModule,
    BarcodeModule,
    MatGridListModule,
    MatIconModule,
    WarehouseModule,
    FolderModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    PropertyModule,
    MatMenuModule,
    MatPaginatorModule,
    EshopModule,
    MatCardModule,
    MatDialogModule,
    PhotoViewerModule,
    ProviderModule
  ]
})
export class ProductModule {}
